module.exports = __webpack_public_path__ + "img/06深圳.0bbfaeca.png";